import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Location } from "src/app/models/Location";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";

@Injectable({
  providedIn: "root",
})
export class LocationService {
  private baseUrl_V2 = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/location`;

  constructor(private http: HttpClient) {}

  public getList(companyId: string, departmentName: string): Observable<Location[]> {
    const url = departmentName
      ? `${this.baseUrl_V2}/${companyId}?departmentName=${departmentName}`
      : `${this.baseUrl_V2}/${companyId}`;

    return this.http.get<Location[]>(url);
  }

  create(companyId: string, location: Location) {
    return this.http.post(this.baseUrl_V2 + "/" + companyId, location);
  }

  update(companyId: string, location: Location) {
    return this.http.put(this.baseUrl_V2 + "/" + companyId, location);
  }

  move(companyId: string, location: Location) {
    return this.http.put(this.baseUrl_V2 + "/" + companyId + "/move", location);
  }

  delete(companyId: string, location: Location) {
    return this.http.post(this.baseUrl_V2 + "/" + companyId + "/delete", location);
  }
}
